import { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';

const CustomerFeedback = ({ user }) => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [filterStatus, setFilterStatus] = useState('all');

  useEffect(() => {
    if (user) {
      fetchFeedbacks();
    }
  }, [user]);

  const fetchFeedbacks = async () => {
    try {
      const snapshot = await getDocs(collection(db, 'feedback'));
      const feedbackList = snapshot.docs.map(doc => {
        const data = doc.data();
        // Handle timestamp as a string or Firestore Timestamp
        let timestamp = data.timestamp;
        if (typeof timestamp === 'string') {
          timestamp = new Date(timestamp);
        } else if (timestamp && typeof timestamp.toDate === 'function') {
          timestamp = timestamp.toDate();
        } else {
          timestamp = null;
        }
        return {
          id: doc.id,
          ...data,
          timestamp
        };
      });
      setFeedbacks(feedbackList);
    } catch (error) {
      console.error('Error fetching feedback:', error);
    }
  };

  const markAsReviewed = async (feedbackId, currentStatus) => {
    if (!user || !user.email.endsWith('@kactuskwenchers.com')) {
      alert('Unauthorized');
      return;
    }
    try {
      await updateDoc(doc(db, 'feedback', feedbackId), {
        reviewed: !currentStatus,
        updatedAt: new Date()
      });
      fetchFeedbacks();
    } catch (error) {
      console.error('Error updating feedback:', error);
      alert('Failed to update feedback: ' + error.message);
    }
  };

  const filteredFeedbacks = feedbacks.filter(feedback => {
    if (filterStatus === 'all') return true;
    return filterStatus === 'reviewed' ? feedback.reviewed : !feedback.reviewed;
  });

  return (
    <div>
      <h2>Customer Feedback</h2>
      <div className="filter-section">
        <select onChange={e => setFilterStatus(e.target.value)} value={filterStatus}>
          <option value="all">All Feedback</option>
          <option value="unreviewed">Unreviewed</option>
          <option value="reviewed">Reviewed</option>
        </select>
      </div>
      <div className="feedback-grid">
        {filteredFeedbacks.length === 0 ? (
          <p>No feedback found.</p>
        ) : (
          filteredFeedbacks.map(feedback => (
            <div key={feedback.id} className="feedback-card">
              <p><strong>Rating:</strong> {feedback.rating}/5</p>
              <p><strong>Comment:</strong> {feedback.comment || 'N/A'}</p>
              <p><strong>Date:</strong> {feedback.timestamp ? feedback.timestamp.toLocaleDateString() : 'N/A'}</p>
              <p><strong>Status:</strong> {feedback.reviewed ? 'Reviewed' : 'Unreviewed'}</p>
              <div className="actions">
                <button
                  className={feedback.reviewed ? 'unreview-button' : 'review-button'}
                  onClick={() => markAsReviewed(feedback.id, feedback.reviewed)}
                >
                  {feedback.reviewed ? 'Mark as Unreviewed' : 'Mark as Reviewed'}
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CustomerFeedback;